var pug = require("!../../../../../.yarn/cache/pug-runtime-npm-3.0.1-13038c62ae-d34ee1b951.zip/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (device, directo, dominio, encodeURIComponent) {
      



pug_mixins["imagen"] = pug_interp = function(nombreImg, anchoImg, altoImg, pieFoto, retina, lazy){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (retina === undefined) {
if (lazy) {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg),"loading": "lazy"},attributes]), true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg)},attributes]), true)) + "\u003E";
}
}
else {
if (lazy) {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"srcset": pug.escape(nombreImg+", "+retina+" 2x"),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg),"loading": "lazy"},attributes]), true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(nombreImg),"srcset": pug.escape(nombreImg+", "+retina+" 2x"),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg)},attributes]), true)) + "\u003E";
}
}
};




pug_mixins["imagenContenido"] = pug_interp = function(urlCompleta, anchoImg, altoImg, pieFoto, lazy, srcSet, sizes){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (lazy) {
pug_html = pug_html + "\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(urlCompleta),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg),"loading": "lazy"},attributes]), true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Clink" + (" rel=\"preload\""+pug.attr("href", urlCompleta, true, true)+" as=\"image\"") + "\u003E\u003Cimg" + (pug.attrs(pug.merge([{"src": pug.escape(urlCompleta),"alt": pug.escape(pieFoto),"width": pug.escape(anchoImg),"height": pug.escape(altoImg),"fetchpriority": "high"},attributes]), true)) + "\u003E";
}
};








pug_mixins["icono"] = pug_interp = function(icon){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Csvg" + (pug.attrs(pug.merge([{"class": "icono","viewBox": "0 0 24 24","width": "24","height": "24"},attributes]), true)) + "\u003E";
switch (icon){
case 'aspa':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M6 19a1 1 0 0 1-.707-.293 1 1 0 0 1 0-1.414l12-12a1 1 0 0 1 1.414 0 1 1 0 0 1 0 1.414l-12 12A1 1 0 0 1 6 19Z\"\u002F\u003E\u003Cpath d=\"M18 19a1 1 0 0 1-.707-.293l-12-12a1 1 0 0 1 0-1.414 1 1 0 0 1 1.414 0l12 12A1 1 0 0 1 18 19Z\"\u002F\u003E\n";
  break;
case 'buscar':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M11 2a9 9 0 1 1-9 9 9.01 9.01 0 0 1 9-9Zm0 16a7 7 0 1 0-7-7 7.008 7.008 0 0 0 7 7Z\"\u002F\u003E\u003Cpath d=\"M21 22a1 1 0 0 1-.707-.293l-4.35-4.35a1 1 0 0 1 0-1.414 1 1 0 0 1 1.414 0l4.35 4.35A1 1 0 0 1 21 22Z\"\u002F\u003E\n";
  break;
case 'calendario':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M5 3h14a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Zm14 18a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1Z\"\u002F\u003E\u003Cpath d=\"M16 7a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1 1 1 0 0 1 1 1v4a1 1 0 0 1-1 1ZM8 7a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1 1 1 0 0 1 1 1v4a1 1 0 0 1-1 1ZM21 11H3a1 1 0 0 1-1-1 1 1 0 0 1 1-1h18a1 1 0 0 1 1 1 1 1 0 0 1-1 1Z\"\u002F\u003E\n";
  break;
case 'check':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M9 19a1 1 0 0 1-.707-.293l-5-5a1 1 0 1 1 1.414-1.414L9 16.586 19.293 6.293a1 1 0 0 1 1.414 1.414l-11 11A1 1 0 0 1 9 19Z\"\u002F\u003E\n";
  break;
case 'comentarios':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M12.478 2H13.055A9.469 9.469 0 0 1 22 10.945v.555a9.5 9.5 0 0 1-9.5 9.5h-.022a9.431 9.431 0 0 1-3.844-.824l-5.318 1.773a1 1 0 0 1-1.265-1.265l1.773-5.318A9.5 9.5 0 0 1 12.478 2Zm.493 2h-.493a7.495 7.495 0 0 0-6.685 10.849 1 1 0 0 1 .056.767l-1.268 3.8 3.8-1.268a1 1 0 0 1 .767.056 7.416 7.416 0 0 0 3.33.796h.022a7.509 7.509 0 0 0 7.5-7.5v-.474A7.471 7.471 0 0 0 12.972 4Z\"\u002F\u003E\n";
  break;
case 'compartir':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M18 1a4 4 0 1 1-4 4 4 4 0 0 1 4-4Zm0 6a2 2 0 1 0-2-2 2 2 0 0 0 2 2ZM6 8a4 4 0 1 1-4 4 4 4 0 0 1 4-4Zm0 6a2 2 0 1 0-2-2 2 2 0 0 0 2 2ZM18 15a4 4 0 1 1-4 4 4 4 0 0 1 4-4Zm0 6a2 2 0 1 0-2-2 2 2 0 0 0 2 2Z\"\u002F\u003E\u003Cpath d=\"M15.419 18.49a1 1 0 0 1-.5-.136l-6.829-3.98a1 1 0 0 1-.364-1.364 1 1 0 0 1 1.364-.364l6.83 3.98a1 1 0 0 1-.5 1.864ZM8.59 11.49a1 1 0 0 1-.865-.5 1 1 0 0 1 .365-1.364l6.82-3.98a1 1 0 0 1 1.364.364 1 1 0 0 1-.36 1.364l-6.824 3.98a1 1 0 0 1-.5.136Z\"\u002F\u003E\n";
  break;
case 'desplegable':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M12 16a1 1 0 0 1-.707-.293l-6-6a1 1 0 0 1 1.414-1.414L12 13.586l5.293-5.293a1 1 0 0 1 1.414 1.414l-6 6A1 1 0 0 1 12 16Z\"\u002F\u003E\n";
  break;
case 'flechaDerecha':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M7 23a1 1 0 0 1-.707-1.707L15.586 12 6.293 2.707a1 1 0 0 1 1.414-1.414l10 10a1 1 0 0 1 0 1.414l-10 10A1 1 0 0 1 7 23Z\"\u002F\u003E\n";
  break;
case 'flechaIzquierda':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M17 23a1 1 0 0 1-.707-.293l-10-10a1 1 0 0 1 0-1.414l10-10a1 1 0 0 1 1.414 1.414L8.414 12l9.293 9.293A1 1 0 0 1 17 23Z\"\u002F\u003E\n";
  break;
case 'flechaMiniDerecha':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M8.333 8v8a1 1 0 0 0 1.6.8l5.333-4a1 1 0 0 0 0-1.6l-5.333-4a1 1 0 0 0-1.6.8Z\"\u002F\u003E\n";
  break;
case 'flechaSiguiente':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M16 18a1 1 0 0 1-.707-1.707L19.586 12l-4.293-4.293a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414l-5 5A1 1 0 0 1 16 18Z\"\u002F\u003E\u003Cpath d=\"M20 13H3a1 1 0 0 1-1-1 1 1 0 0 1 1-1h17a1 1 0 0 1 1 1 1 1 0 0 1-1 1Z\"\u002F\u003E\n";
  break;
case 'galeria':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M21 22H3a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3h3.465l1.7-2.555A1 1 0 0 1 9 2h6a1 1 0 0 1 .832.445L17.535 5H21a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3ZM3 7a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-4a1 1 0 0 1-.832-.445L14.465 4h-4.93l-1.7 2.555A1 1 0 0 1 7 7Z\"\u002F\u003E\u003Cpath d=\"M12 8a5 5 0 1 1-5 5 5.006 5.006 0 0 1 5-5Zm0 8a3 3 0 1 0-3-3 3 3 0 0 0 3 3Z\"\u002F\u003E\n";
  break;
case 'galeriaIcon':
pug_html = pug_html + "\u003Cg filter=\"url(#a)\"\u003E\u003Ccircle cx=\"24\" cy=\"20\" r=\"20\" fill=\"#DA291C\"\u002F\u003E\u003C\u002Fg\u003E\u003Cpath fill=\"#F2F2F2\" fill-rule=\"evenodd\" d=\"M25.764 11a3 3 0 0 1 2.683 1.658l.895 1.79a1 1 0 0 0 .894.552H31a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H17a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3h.764a1 1 0 0 0 .894-.553l.895-1.789A3 3 0 0 1 22.236 11h3.528Zm0 2h-3.528a1 1 0 0 0-.894.553l-.895 1.789A3 3 0 0 1 17.764 17H17a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-.764a3 3 0 0 1-2.683-1.658l-.895-1.79a1 1 0 0 0-.894-.552ZM24 17a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z\" clip-rule=\"evenodd\"\u002F\u003E\u003Cdefs\u003E\u003Cfilter id=\"a\" width=\"48\" height=\"48\" x=\"0\" y=\"0\" color-interpolation-filters=\"sRGB\" filterUnits=\"userSpaceOnUse\"\u003E\u003CfeFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"\u002F\u003E\u003CfeColorMatrix in=\"SourceAlpha\" result=\"hardAlpha\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\"\u002F\u003E\u003CfeOffset dy=\"4\"\u002F\u003E\u003CfeGaussianBlur stdDeviation=\"2\"\u002F\u003E\u003CfeComposite in2=\"hardAlpha\" operator=\"out\"\u002F\u003E\u003CfeColorMatrix values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0\"\u002F\u003E\u003CfeBlend in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_2265_22995\"\u002F\u003E\u003CfeBlend in=\"SourceGraphic\" in2=\"effect1_dropShadow_2265_22995\" result=\"shape\"\u002F\u003E\u003C\u002Ffilter\u003E\u003C\u002Fdefs\u003E\n";
  break;
case 'masHorizontal':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M12 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2ZM19 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2ZM5 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2Z\"\u002F\u003E\n";
  break;
case 'menu':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M18 13H3a1 1 0 0 1-1-1 1 1 0 0 1 1-1h15a1 1 0 0 1 1 1 1 1 0 0 1-1 1ZM21 7H3a1 1 0 0 1-1-1 1 1 0 0 1 1-1h18a1 1 0 0 1 1 1 1 1 0 0 1-1 1ZM15 19H3a1 1 0 0 1-1-1 1 1 0 0 1 1-1h12a1 1 0 0 1 1 1 1 1 0 0 1-1 1Z\"\u002F\u003E\n";
  break;
case 'puntaAbajo':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M12.5 16.5a1 1 0 0 1-.707-.293l-6-6a1 1 0 0 1 1.414-1.414l5.293 5.293 5.293-5.293a1 1 0 0 1 1.414 1.414l-6 6a1 1 0 0 1-.707.293Z\"\u002F\u003E\n";
  break;
case 'puntaArriba':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M18.5 16.5a1 1 0 0 1-.707-.293L12.5 10.914l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0l6 6A1 1 0 0 1 18.5 16.5Z\"\u002F\u003E\n";
  break;
case 'puntaDerecha':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M9.5 19.5a1 1 0 0 1-.707-1.707l5.293-5.293-5.293-5.293a1 1 0 1 1 1.414-1.414l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-.707.293Z\"\u002F\u003E\n";
  break;
case 'puntaIzquierda':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M15.5 19.5a1 1 0 0 1-.707-.293l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414L10.914 12.5l5.293 5.293A1 1 0 0 1 15.5 19.5Z\"\u002F\u003E\n";
  break;
case 'usuario':
pug_html = pug_html + "\u003Cpath fill=\"none\" d=\"M0 0h24v24H0z\"\u002F\u003E\u003Cpath d=\"M18 22a1 1 0 0 1-1-1v-2a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h4a5.006 5.006 0 0 1 5 5v2a1 1 0 0 1-1 1ZM12 2a5 5 0 1 1-5 5 5.006 5.006 0 0 1 5-5Zm0 8a3 3 0 1 0-3-3 3 3 0 0 0 3 3Z\"\u002F\u003E\n";
  break;
case 'rrssFacebook':
pug_html = pug_html + "\u003Cpath d=\"M16.5 3v3.375h-2.25A1.13 1.13 0 0 0 13.125 7.5v2.25H16.5v3.375h-3.375V21H9.75v-7.875H7.5V9.75h2.25V6.937A3.934 3.934 0 0 1 13.688 3H16.5Z\"\u002F\u003E\n";
  break;
case 'rrssInstagram':
pug_html = pug_html + "\u003Cpath d=\"M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3Z\"\u002F\u003E\n";
  break;
case 'rrssTwitter':
pug_html = pug_html + "\u003Cpath d=\"M21 6.265a7.26 7.26 0 0 1-2.117.609 3.776 3.776 0 0 0 1.618-2.1 7.32 7.32 0 0 1-2.34.926 3.594 3.594 0 0 0-2.719-1.2c-2.022 0-3.674 1.694-3.674 3.785 0 .3.034.591.094.865-3.063-.159-5.79-1.668-7.606-3.953a3.823 3.823 0 0 0-.499 1.897c0 1.315.645 2.48 1.644 3.141a3.576 3.576 0 0 1-1.678-.441v.027c0 1.835 1.273 3.37 2.96 3.714a3.522 3.522 0 0 1-1.661.062c.465 1.491 1.815 2.603 3.442 2.629a7.217 7.217 0 0 1-4.586 1.624c-.293 0-.585-.018-.878-.053A10.257 10.257 0 0 0 8.662 19.5c6.78 0 10.505-5.771 10.505-10.774 0-.167 0-.326-.008-.494A7.495 7.495 0 0 0 21 6.265Z\"\u002F\u003E\n";
  break;
case 'rrssTelegram':
pug_html = pug_html + "\u003Cpath d=\"M18.384 22.779a1.19 1.19 0 0 0 1.107.145 1.16 1.16 0 0 0 .724-.84C21.084 18 23.192 7.663 23.983 3.948a.78.78 0 0 0-.26-.758.8.8 0 0 0-.797-.14C18.733 4.602 5.82 9.447.542 11.4a.827.827 0 0 0-.542.799c.012.354.25.661.593.764 2.367.708 5.474 1.693 5.474 1.693s1.452 4.385 2.209 6.615c.095.28.314.5.603.576a.866.866 0 0 0 .811-.207l3.096-2.923s3.572 2.619 5.598 4.062Zm-11.01-8.677 1.679 5.538.373-3.507 10.185-9.186a.277.277 0 0 0 .033-.377.284.284 0 0 0-.376-.064L7.374 14.102Z\"\u002F\u003E\n";
  break;
case 'rrssX':
pug_html = pug_html + "\u003Csvg viewBox=\"0 0 24 24\"\u003E\u003Cpath d=\"M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z\"\u002F\u003E\u003C\u002Fsvg\u003E\n";
  break;
case 'rrssWhatsapp':
pug_html = pug_html + "\u003Cpath d=\"M16.75 13.96c.25.13.41.2.46.3.06.11.04.61-.21 1.18-.2.56-1.24 1.1-1.7 1.12-.46.02-.47.36-2.96-.73-2.49-1.09-3.99-3.75-4.11-3.92-.12-.17-.96-1.38-.92-2.61.05-1.22.69-1.8.95-2.04.24-.26.51-.29.68-.26h.47c.15 0 .36-.06.55.45l.69 1.87c.06.13.1.28.01.44l-.27.41-.39.42c-.12.12-.26.25-.12.5.12.26.62 1.09 1.32 1.78.91.88 1.71 1.17 1.95 1.3.24.14.39.12.54-.04l.81-.94c.19-.25.35-.19.58-.11l1.67.88M12 2a10 10 0 0 1 10 10 10 10 0 0 1-10 10c-1.97 0-3.8-.57-5.35-1.55L2 22l1.55-4.65A9.969 9.969 0 0 1 2 12 10 10 0 0 1 12 2m0 2a8 8 0 0 0-8 8c0 1.72.54 3.31 1.46 4.61L4.5 19.5l2.89-.96A7.95 7.95 0 0 0 12 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8Z\"\u002F\u003E\n";
  break;
case 'rrssYoutube':
pug_html = pug_html + "\u003Cpath d=\"m10 15 5.19-3L10 9v6m11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73Z\"\u002F\u003E\n";
  break;
case 'rrssTikTok':
pug_html = pug_html + "\u003Csvg xmlns=\"http:\u002F\u002Fwww.w3.org\u002F2000\u002Fsvg\" xml:space=\"preserve\" style=\"enable-background:new 0 0 50 50\" viewBox=\"0 0 50 50\"\u003E\u003Cpath d=\"M41 4H9C6.2 4 4 6.2 4 9v32c0 2.8 2.2 5 5 5h32c2.8 0 5-2.2 5-5V9c0-2.8-2.2-5-5-5zm-4 18.3h-.7c-2.6 0-4.9-1.3-6.3-3.4v11.5c0 4.7-3.8 8.5-8.5 8.5S13 35.2 13 30.5s3.8-8.5 8.5-8.5h.5v4.2c-.2 0-.3-.1-.5-.1-2.4 0-4.4 1.9-4.4 4.4s1.9 4.4 4.4 4.4S26 33 26 30.6V11h4c.4 3.6 3.3 6.4 6.9 6.7v4.6z\" style=\"fill:#7e7c66\"\u002F\u003E\u003C\u002Fsvg\u003E\n";
  break;
case 'video':
pug_html = pug_html + "\u003Cpath fill=\"#FFF\" fill-rule=\"evenodd\" d=\"m6.51.83 14.4 9.6c1.49.87 1.58 2.95.26 3.97L6.51 24.17c-1.6.93-3.61-.22-3.61-2.07V2.9c0-1.85 2.01-3 3.61-2.07z\" clip-rule=\"evenodd\"\u002F\u003E\n";
  break;
case 'reproduciendo':
pug_html = pug_html + "\u003Cpath fill=\"#fff\" fill-rule=\"evenodd\" d=\"M10.731 17.46H6.923V.515h3.808V17.46Zm6.347 0H13.27V8.987h3.808v8.473Zm-16.502 0h3.808v-5.084H.576v5.084Zm22.85 0h-3.809V5.598h3.808V17.46Z\" class=\"bars\" clip-rule=\"evenodd\"\u002F\u003E\n";
  break;
case 'google':
pug_html = pug_html + "\u003Cpath fill=\"#4285F4\" d=\"M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z\"\u002F\u003E\u003Cpath fill=\"#34A853\" d=\"M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z\"\u002F\u003E\u003Cpath fill=\"#FBBC05\" d=\"M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z\"\u002F\u003E\u003Cpath fill=\"#EA4335\" d=\"M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z\"\u002F\u003E\u003Cpath fill=\"none\" d=\"M1 1h22v22H1z\"\u002F\u003E\n";
  break;
}
pug_html = pug_html + "\u003C\u002Fsvg\u003E";
};
pug_mixins["boton"] = pug_interp = function(tag, accion, href, id){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (tag === 'a') {
pug_html = pug_html + "\u003Ca" + (pug.attrs(pug.merge([{"class": "boton","href": pug.escape(href),"title": pug.escape(accion)},attributes]), true)) + "\u003E\u003Cspan class=\"accion parrafo\"\u003E" + (pug.escape(null == (pug_interp = accion) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003C" + (tag) + (pug.attrs(pug.merge([{"class": "boton","id": pug.escape(id)},attributes]), true)) + "\u003E\u003Cspan class=\"accion parrafo\"\u003E" + (pug.escape(null == (pug_interp = accion) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002F" + (tag) + "\u003E";
}
};
pug_mixins["botonIcono"] = pug_interp = function(tag, icono, accion, href, target){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (tag === 'a') {
if (target === undefined) {
pug_html = pug_html + "\u003Ca" + (pug.attrs(pug.merge([{"class": "boton solo-icono","href": pug.escape(href),"title": pug.escape(accion)},attributes]), true)) + "\u003E";
pug_mixins["icono"](icono);
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (pug.attrs(pug.merge([{"class": "boton solo-icono","href": pug.escape(href),"title": pug.escape(accion),"target": pug.escape(target)},attributes]), true)) + "\u003E";
pug_mixins["icono"](icono);
pug_html = pug_html + "\u003C\u002Fa\u003E";
}
}
else {
if (accion === 'Compartir') {
pug_html = pug_html + "\u003C" + (tag) + (pug.attrs(pug.merge([{"class": "boton solo-icono boton-share"},attributes]), true)) + "\u003E";
pug_mixins["imagen"]('/img/compartir.svg','24','24','Compartir');
pug_html = pug_html + "\u003C\u002F" + (tag) + "\u003E";
}
else {
pug_html = pug_html + "\u003C" + (tag) + (pug.attrs(pug.merge([{"class": "boton solo-icono"},attributes]), true)) + "\u003E";
pug_mixins["icono"](icono);
pug_html = pug_html + "\u003C\u002F" + (tag) + "\u003E";
}
}
};











































































































pug_mixins["filaClasificacion"] = pug_interp = function(puesto, imagen, equipo, corto, clase, variacion, ptsTotales, pjTotales, pgTotales, peTotales, ppTotales, gfTotales, gcTotales, ptsCasa, pjCasa, pgCasa, peCasa, ppCasa, gfCasa, gcCasa, ptsFuera, pjFuera, pgFuera, peFuera, ppFuera, gfFuera, gcFuera, portadilla, selecciones){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Ctr" + (pug.attr("class", pug.classes([clase], [true]), false, true)) + "\u003E\u003Ctd class=\"equipo\"\u003E\u003Cdiv" + (pug.attrs(pug.merge([{"class": "pila"},attributes]), true)) + "\u003E\u003Cspan class=\"posicion\"\u003E" + (pug.escape(null == (pug_interp = puesto) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan" + (pug.attr("class", pug.classes([['tescudo', selecciones ? 'flag' : ''].join(' ')], [true]), false, true)) + "\u003E";
pug_mixins["imagen"](imagen.normal, '24', '24', equipo, imagen.retina);
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003Cspan class=\"label\"\u003E";
if (portadilla) {
pug_html = pug_html + "\u003Ca" + (pug.attr("href", portadilla, true, true)) + "\u003E\u003Cspan class=\"solo-desktop\"\u003E" + (pug.escape(null == (pug_interp = equipo) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"solo-movil\"\u003E" + (pug.escape(null == (pug_interp = corto) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"solo-desktop\"\u003E" + (pug.escape(null == (pug_interp = equipo) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"solo-movil\"\u003E" + (pug.escape(null == (pug_interp = corto) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
if (clase.split(' ').includes('sube')) {
pug_mixins["icono"].call({
attributes: {"class": "sube"}
}, 'puntaArriba');
}
else
if (clase.split(' ').includes('baja')) {
pug_mixins["icono"].call({
attributes: {"class": "baja"}
}, 'puntaAbajo');
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"total fondo-negro texto-blanco\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = ptsTotales) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = pjTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = pgTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = peTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = ppTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = gfTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"total\"\u003E" + (pug.escape(null == (pug_interp = gcTotales) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa fondo-negro texto-blanco\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = ptsCasa) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = pjCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = pgCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = peCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = ppCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = gfCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"casa\"\u003E" + (pug.escape(null == (pug_interp = gcCasa) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera fondo-negro texto-blanco\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = ptsFuera) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = pjFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = pgFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = peFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = ppFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = gfFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003Ctd class=\"fuera\"\u003E" + (pug.escape(null == (pug_interp = gcFuera) ? "" : pug_interp)) + "\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E";
};








































































































































































pug_mixins["autor"] = pug_interp = function(autor, compartir, fecha, fecha_formateada, fecha_amigable, lectura, titular, titularRrss, idCompartir, url, params){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cspan class=\"firma-portada pila flex-align-center nota\"\u003E";
if ((!params || params && params.avatar)) {
if (autor.foto !== undefined) {
if (autor.url !== undefined) {
pug_html = pug_html + "\u003Cspan class=\"tavatar\"\u003E\u003Ca" + (" class=\"avatar\""+pug.attr("href", url, true, true)+pug.attr("title", autor.apodo, true, true)) + "\u003E";
pug_mixins["imagen"](autor.foto, '32', '32', autor.apodo, autor.foto2x);
pug_html = pug_html + "\u003C\u002Fa\u003E\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"tavatar\"\u003E";
pug_mixins["imagen"].call({
attributes: {"class": "avatar"}
}, autor.foto, '32', '32', autor.apodo, autor.foto2x);
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
}
}
pug_html = pug_html + "\u003Cspan class=\"datos\"\u003E\u003Cspan class=\"pila flex-align-center\"\u003E";
if (autor.url !== undefined) {
pug_html = pug_html + "\u003Ca" + (" class=\"enlace-oscuro\""+pug.attr("href", autor.url, true, true)+pug.attr("title", autor.apodo, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = autor.apodo) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"enlace-oscuro\"\u003E" + (pug.escape(null == (pug_interp = autor.apodo) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003C!--if (params && params.fechaAmigable)--\u003E\u003C!--  time.uTime.texto-suave(data=fecha) #{fecha_amigable}--\u003E\u003C!--else--\u003E\u003Ctime" + (" class=\"uTime texto-oscuro\""+pug.attr("datetime", fecha, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = fecha_formateada) ? "" : pug_interp)) + "\u003C\u002Ftime\u003E\u003C\u002Fspan\u003E";
if (compartir) {
pug_mixins["botonIcono"].call({
attributes: {"for": pug.escape(idCompartir)}
}, 'label', 'compartir', 'Compartir', '');
}
pug_html = pug_html + "\u003C\u002Fspan\u003E\u003Cinput" + (" class=\"oculto compartir-portada\""+" type=\"checkbox\""+pug.attr("id", idCompartir, true, true)+pug.attr("name", idCompartir, true, true)) + "\u003E\u003Cdiv class=\"capa-compartir fondo-negro-transparente flex-center flex-align-center flex-vertical\"\u003E";
if (block) {
block && block();
}
pug_html = pug_html + "\u003Cp class=\"texto-blanco texto-centrado titulo-1\"\u003E" + (pug.escape(null == (pug_interp = titular) ? "" : pug_interp)) + "\u003C\u002Fp\u003E\u003Cdiv class=\"botonera centro\"\u003E";
const titulo = encodeURIComponent(titularRrss)
pug_mixins["botonIcono"].call({
attributes: {"class": "fondo-facebook"}
}, 'a', 'rrssFacebook', 'Compartir en Facebook', 'https://www.facebook.com/sharer.php?u=' + url, '_blank');
pug_mixins["botonIcono"].call({
attributes: {"class": "fondo-twitter"}
}, 'a', 'rrssX', 'Compartir en X', 'https://twitter.com/intent/tweet?text=' + titulo + '&url=' + url + '&related=&via=Estadio_ED', '_blank');
pug_mixins["botonIcono"].call({
attributes: {"class": "fondo-whatsapp"}
}, 'a', 'rrssWhatsapp', 'Compartir en Whatsapp', 'https://api.whatsapp.com/send?text=' + titulo + '%20' + url, '_blank');
pug_mixins["botonIcono"].call({
attributes: {"for": pug.escape(idCompartir)}
}, 'label', 'aspa', '', '');
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};














pug_mixins["entradaDirecto"] = pug_interp = function(dominio, comentario){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (" class=\"narracion-entrada pila v-movil\""+pug.attr("data-comentario", comentario.id, true, true)+pug.attr("data-longitud", comentario.longitud, true, true)) + "\u003E";
if (comentario.temporalText && comentario.temporalText != '') {
pug_html = pug_html + "\u003Ctime class=\"entrada-hora menor fondo-alt\"\u003E\u003Cstrong\u003E" + (pug.escape(null == (pug_interp = comentario.temporalText + (comentario.temporalTextTipo == 'minuto' ? '\'':'')) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E\u003C\u002Ftime\u003E\u003Cspan" + (pug.attr("class", pug.classes(["contenido-entrada","pila-v",(comentario.destacado ? 'fijada' : '')], [false,false,true]), false, true)) + "\u003E";
pug_mixins["comentarioDirecto"](dominio, comentario.tipo, (comentario.icono ? comentario.icono : undefined), comentario.comentario_html, comentario.destacado);
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan" + (pug.attr("class", pug.classes(["contenido-entrada","pila-v",(comentario.destacado ? 'fijada' : '')], [false,false,true]), false, true)) + "\u003E";
pug_mixins["comentarioDirecto"](dominio, comentario.tipo, (comentario.icono ? comentario.icono : undefined), comentario.comentario_html, comentario.destacado);
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["comentarioDirecto"] = pug_interp = function(dominio, tipo, icono, comentario, destacado){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["pila",(tipo=='opinion' ? 'fondo-enlace' : (tipo == 'destacado' ? 'fondo-alt': ''))], [false,true]), false, true)) + "\u003E";
if (icono) {
pug_html = pug_html + "\u003Cimg" + (" class=\"icono-directo\""+pug.attr("src", dominio+'/img/directo/'+icono.file, true, true)+pug.attr("alt", icono.nombre, true, true)) + "\u003E";
}
if (comentario) {
if ((!destacado)) {
pug_html = pug_html + "\u003Cspan class=\"pila-v ancho-completo\"\u003E" + (null == (pug_interp = comentario) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + "\u003Cspan class=\"pila-v ancho-completo fijada\"\u003E\u003Cdiv class=\"contenido-pin\"\u003E" + (null == (pug_interp = comentario) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
pug_mixins["imagen"].call({
attributes: {"class": "icono-pin"}
}, '/img/pin.svg','15','15','Comentario fijado');
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};






pug_html = pug_html + "\u003Cspan class=\"contenedor-directo\"\u003E\u003Cdiv class=\"controles-directo flex-space-between flex-align-center\"\u003E\u003Cp class=\"parrafo\"\u003E\u003Cstrong\u003EMinuto a minuto\u003C\u002Fstrong\u003E\u003C\u002Fp\u003E";
if (directo.isDirecto) {
pug_mixins["boton"].call({
attributes: {"class": "cuerpo actualizar-directo"}
}, 'span', 'Actualizar narración', '');
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"narracion-directo pila-v\""+pug.attr("data-directo", directo.id, true, true)+pug.attr("data-device", device, true, true)) + "\u003E";
let i = 0
// iterate directo.comentarios
;(function(){
  var $$obj = directo.comentarios;
  if ('number' == typeof $$obj.length) {
      for (var key = 0, $$l = $$obj.length; key < $$l; key++) {
        var comentario = $$obj[key];
pug_mixins["entradaDirecto"](dominio, comentario);
if (directo.indicesPublicidad.includes(key) && directo.adInlineAvail[i]!==undefined) {
pug_html = pug_html + "\u003Caside" + (" class=\"publicidad\""+pug.attr("id", "publicidad-"+directo.adInlineAvail[i], true, true)) + "\u003E\u003Cdiv" + (" class=\"edp\""+pug.attr("id", directo.adInlineAvail[i], true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Faside\u003E";
i=i+1
}
      }
  } else {
    var $$l = 0;
    for (var key in $$obj) {
      $$l++;
      var comentario = $$obj[key];
pug_mixins["entradaDirecto"](dominio, comentario);
if (directo.indicesPublicidad.includes(key) && directo.adInlineAvail[i]!==undefined) {
pug_html = pug_html + "\u003Caside" + (" class=\"publicidad\""+pug.attr("id", "publicidad-"+directo.adInlineAvail[i], true, true)) + "\u003E\u003Cdiv" + (" class=\"edp\""+pug.attr("id", directo.adInlineAvail[i], true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Faside\u003E";
i=i+1
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C!--.botonera.centro: +boton('span', 'Ver más', '').cuerpo.cargar-mas(class=!directo.masComentarios?'disabled':'')--\u003E\u003C\u002Fspan\u003E";
    }.call(this, "device" in locals_for_with ?
        locals_for_with.device :
        typeof device !== 'undefined' ? device : undefined, "directo" in locals_for_with ?
        locals_for_with.directo :
        typeof directo !== 'undefined' ? directo : undefined, "dominio" in locals_for_with ?
        locals_for_with.dominio :
        typeof dominio !== 'undefined' ? dominio : undefined, "encodeURIComponent" in locals_for_with ?
        locals_for_with.encodeURIComponent :
        typeof encodeURIComponent !== 'undefined' ? encodeURIComponent : undefined));
    ;;return pug_html;};
module.exports = template;